import { Button } from '../../../../cdl/Button/Button';
import { useDrawer } from '../../../../cdl/Drawer/useDrawer.hook';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconPlus } from '../../../../common/icons/cdl/Plus';
import { Box } from '../../../../common/ui/Box';

import { CreateSurchargeForm } from './CreateSurchargeForm';
import { SurchargesTable } from './SurchargesTable';

interface SurchargesProps {
    groupId: string;
}

export const Surcharges = ({ groupId }: SurchargesProps) => {
    const { push, pop } = useDrawer();

    const openSurchargeCreateModal = () => {
        const drawerId = push({
            header: { title: translate('surcharges.create') },
            content: <CreateSurchargeForm groupId={groupId} onSuccess={() => pop(drawerId)} />,
            width: '15vw',
        });
    };

    return (
        <Box display="flex" flexDirection="column" gap={16}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Text variant="subtitle1" as="h2">
                    {translate('surcharges.headline')}
                </Text>
                <Button LeadingIcon={IconPlus} onClick={openSurchargeCreateModal}>
                    {translate('surcharges.create')}
                </Button>
            </Box>
            <SurchargesTable groupId={groupId} />
        </Box>
    );
};
